const styles = {
  root: {
    textAlign: { xs: 'left', md: 'center' },
    mt: 3,
    paddingX: { xs: 0, md: 1, lg: 2 },
    alignItems: 'center',
    justifyContent: { xs: 'left', md: 'center' },
  },
  title: {
    mb: 1,
  },
  description: {
    textAlign: { xs: 'left', md: 'left', lg: 'center' },
  },
  icon: {
    mr: { xs: 2, lg: 0 },
  },

}

export default styles
